// Copyright (c) 2020 Deere & Company

import UserDelearDataCollections, { getDefaultState } from '../state/userDelaerDataCollections';
import actions from '../../../../sharedmodules/actions-list';

const getUserDelaerMappedData = (state, action) => UserDelearDataCollections.update(state, {
    $set: action.data.length > 0 ? action.data : getDefaultState(),
});

const resetUserDelaerMappedData = (state) => UserDelearDataCollections.update(state, {
    $set: getDefaultState(),
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_USER_DEALER_MAPPED_DATA]: getUserDelaerMappedData,
        [actions.RESET_USER_DEALER_MAPPED_DATA]: resetUserDelaerMappedData,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
